import { render, staticRenderFns } from "./tableRecord.vue?vue&type=template&id=67772422&scoped=true&"
import script from "./tableRecord.vue?vue&type=script&lang=js&"
export * from "./tableRecord.vue?vue&type=script&lang=js&"
import style0 from "./tableRecord.vue?vue&type=style&index=0&id=67772422&lang=scss&scoped=true&"
import style1 from "./tableRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67772422",
  null
  
)

export default component.exports